import { ChevronRight } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

const More = () => {
  const navigate = useNavigate();

  const handleSignOut = () => {
    navigate("/");
  };

  // const goToProfile = () => {
  //   alert("test profile");
  //   //navigate("/profile");
  // };

  const goToBirthdays = () => {
    navigate("/app/birthdays");
  };
  const goToGatherings = () => {
    navigate("/app/gatherings");
  };
  const goToAdminchat = () => {
    alert("Taking you to whatsapp to chat with family admin");
    //navigate("/profile");
  };
  const goToContributions = () => {
    navigate("/app/contributions");
  };
  const goToHistory = () => {
    navigate("/app/history");
  };

  return (
    <>
      <p style={{ fontFamily: "Open Sans", fontSize: "14" }}>More</p>
      {/* <div
        onClick={goToProfile}
        style={{
          alignItems: "center",
          paddingInline: "10px",
          marginTop: "10px",
          flexDirection: "row",
          display: "flex",
          justifyContent: "space-between",
          backgroundColor: "#779d38",
          height: "50px",
          width: "100%",
          borderRadius: "5px",
          cursor: "pointer",
        }}
      >
        <p
          style={{
            fontFamily: "Open Sans",
            color: "#ffffff",
            marginTop: "7px",
          }}
        >
          Profile
        </p>
        <ChevronRight size={17} style={{ color: "#ffffff" }} />
      </div> */}
      <div
      onClick={goToBirthdays}
        style={{
          alignItems: "center",
          paddingInline: "10px",
          marginTop: "10px",
          flexDirection: "row",
          display: "flex",
          justifyContent: "space-between",
          backgroundColor: "#779d38",
          height: "50px",
          width: "100%",
          borderRadius: "5px",
        }}
      >
        <p
          style={{
            fontFamily: "Open Sans",
            color: "#ffffff",
            marginTop: "7px",
          }}
        >
          Member Birthdays
        </p>
        <ChevronRight size={17} style={{ color: "#ffffff" }} />
      </div>
      <div
       onClick={goToGatherings}
        style={{
          alignItems: "center",
          paddingInline: "10px",
          marginTop: "10px",
          flexDirection: "row",
          display: "flex",
          justifyContent: "space-between",
          backgroundColor: "#779d38",
          height: "50px",
          width: "100%",
          borderRadius: "5px",
        }}
      >
        <p
          style={{
            fontFamily: "Open Sans",
            color: "#ffffff",
            marginTop: "7px",
          }}
        >
          Gatherings
        </p>
        <ChevronRight size={17} style={{ color: "#ffffff" }} />
      </div>
      <div
      onClick={goToAdminchat}
        style={{
          alignItems: "center",
          paddingInline: "10px",
          marginTop: "10px",
          flexDirection: "row",
          display: "flex",
          justifyContent: "space-between",
          backgroundColor: "#779d38",
          height: "50px",
          width: "100%",
          borderRadius: "5px",
        }}
      >
        <p
          style={{
            fontFamily: "Open Sans",
            color: "#ffffff",
            marginTop: "7px",
          }}
        >
          Chat With Admin
        </p>
        <ChevronRight size={17} style={{ color: "#ffffff" }} />
      </div>
      <div
      onClick={goToContributions}
        style={{
          alignItems: "center",
          paddingInline: "10px",
          marginTop: "10px",
          flexDirection: "row",
          display: "flex",
          justifyContent: "space-between",
          backgroundColor: "#779d38",
          height: "50px",
          width: "100%",
          borderRadius: "5px",
        }}
      >
        <p
          style={{
            fontFamily: "Open Sans",
            color: "#ffffff",
            marginTop: "7px",
          }}
        >
          Contributions
        </p>
        <ChevronRight size={17} style={{ color: "#ffffff" }} />
      </div>
      <div
       onClick={goToHistory}
        style={{
          alignItems: "center",
          paddingInline: "10px",
          marginTop: "10px",
          flexDirection: "row",
          display: "flex",
          justifyContent: "space-between",
          backgroundColor: "#779d38",
          height: "50px",
          width: "100%",
          borderRadius: "5px",
        }}
      >
        <p
          style={{
            fontFamily: "Open Sans",
            color: "#ffffff",
            marginTop: "7px",
          }}
        >
          Family History
        </p>
        <ChevronRight size={17} style={{ color: "#ffffff" }} />
      </div>
      <div
        onClick={() => handleSignOut()}
        style={{
          alignItems: "center",
          paddingInline: "10px",
          marginTop: "10px",
          flexDirection: "row",
          display: "flex",
          justifyContent: "space-between",
          backgroundColor: "#779d38",
          height: "50px",
          width: "100%",
          borderRadius: "5px",
        }}
      >
        <p
          style={{
            fontFamily: "Open Sans",
            color: "#ffffff",
            marginTop: "7px",
          }}
        >
          Sign Out
        </p>
        <ChevronRight size={17} style={{ color: "#ffffff" }} />
      </div>
    </>
  );
};

export default More;
